var HSForm_Events = new Object();

HSForm_Events.version = "1.0.0";

HSForm_Events.listen = function () {};

export default HSForm_Events;
